import { QueryParameters as ConductorCampaignQueryParameters } from "@faire/web-api/api/conductor/get";
import { useQuery as useConductorCampaignQuery } from "@faire/web-api/api/conductor/get-hooks";
import { ConductorSurface } from "@faire/web-api/indigofair/data/ConductorSurface";

import { useIsLoggedInRetailer } from "@faire/retailer/lib/isLoggedInRetailer";

export const useConductorCampaign = (
  surface: keyof typeof ConductorSurface | undefined
) => {
  const isLoggedInRetailer = useIsLoggedInRetailer();
  const queryParams = ConductorCampaignQueryParameters.build({
    surface,
  });
  const { data, isPending } = useConductorCampaignQuery(queryParams, {
    enabled: isLoggedInRetailer,
  });

  return {
    conductorViewLayout: data,
    isConductorViewLayoutPending: isPending,
  };
};
